import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Button } from '../../components/ui/Button';
import { Card, SectionTitle } from '../../components/ui/Card';
import { sessions } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
import { useSettings } from '../../contexts/SettingsContext';
export function Sessions() {
  const {
    t,
    tl
  } = useLocale();
  const settings = useSettings();
  const active = sessions.filter(session => !settings.signedOutSessions.includes(session.id));
  const others = active.filter(session => !session.current);
  return <div className="px-2 pb-2" data-id="element-3903" data-mp="322ueikvjwfu3">
      <PageHeader title={t('security.sessions')} subtitle={t('sessions.subtitle')} showBack data-id="element-3904" data-mp="370cf9nzezor0" />

      <SectionTitle data-id="element-3905" data-mp="3b2h6kg2e49ah">{t('sessions.active')}</SectionTitle>
      <ul className="space-y-2" data-id="element-3906" data-mp="3g0iqf37n4cn0">
        {active.map(session => <li key={session.id} data-id="element-3907" data-mp="3g0sgeqsoqjsp">
            <Card className={`p-2 ${session.current ? 'border-gold/45' : ''}`} data-id="element-3908" data-mp="3ngh789gej76z">
              <div className="flex items-start gap-2" data-id="element-3909" data-mp="3nee7uytd01pl">
                <span className="min-w-0 flex-1" data-id="element-3910" data-mp="3jecfjg9ikkmz">
                  <span className="block text-[13.5px] font-medium text-deep" data-id="element-3911" data-mp="3eg16h7r1me5t">
                    {session.device}
                  </span>
                  <span className="mt-[2px] block text-[11.5px] text-muted" data-id="element-3912" data-mp="39hzluidyy6s8">
                    {tl(session.place)} · {tl(session.lastActive)}
                  </span>
                  <span className="mt-1 flex flex-wrap items-center gap-1" data-id="element-3913" data-mp="60hhwm1bhjx3">
                    {session.current && <span className="bee-overline rounded-pill bg-gold px-2 py-[3px] text-[8.5px] font-bold text-deep" data-id="element-3914" data-mp="18r0jw3ypvw6">
                        {t('sessions.thisDevice')}
                      </span>}
                    {session.trusted && <span className="flex items-center gap-1 text-[10.5px] font-medium text-muted" data-id="element-3915" data-mp="oz3js34nrf22">
                        <ShieldCheckIcon size={12} aria-hidden="true" data-id="element-3916" data-mp="2j6xnd5til70q" />
                        {t('sessions.trusted')}
                      </span>}
                  </span>
                </span>
                {!session.current && <Button variant="outline" onClick={() => settings.signOutSession(session.id)} className="shrink-0" data-id="element-3917" data-mp="29gmf572ssbo1">
                    {t('sessions.signOut')}
                  </Button>}
              </div>
            </Card>
          </li>)}
      </ul>

      {others.length > 0 && <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={settings.signOutOthers} data-id="element-3918" data-mp="1qjl7fehuzxge">
          {t('sessions.signOutOthers')}
        </Button>}

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3919" data-mp="3ku82cmp3k36x">
        {t('sessions.note')}
      </p>
    </div>;
}